"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0; // Adapted from:
// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection

var hasWindow = typeof window !== "undefined";

var supportsPassive = function supportsPassive() {
  if (!hasWindow) {
    return false;
  }

  var val = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        val = true;
        return true;
      }
    });
    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
  } catch (e) {}

  return val;
};

var _default = supportsPassive;
exports["default"] = _default;